import React, { useState } from "react";
import UpcomingCarsList from "../components/UpcomingCars/UpcomingCarsList";
import UpcomingCarsDetail from "../components/UpcomingCars/UpcomingCarsDetaill";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
import { defaultValue } from "../components/common/MyCarsOrOtherCarsButton";
import { auctionTypes } from "@common/utils/constants/auction";
import UpcomingCarsDetailReadOnly from "@common/pages/Dashboard/components/UpcomingCars/UpcomingCarsDetaillReadOnly";
import { useLogPageVisitMutation } from "@common/toolkit/appConfiguration/appConfigurationApi.js";

const UpcomingCars = () => {

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  const location = useLocation();

  const subRoute = location?.pathname?.split?.(`${routes?.dashboardNavigation}/`)?.[1]?.split?.(`/`)?.[0];
  const Vehicle_Id = location?.pathname?.split?.(`${routes.upcomingCars}/`)?.[1]?.split?.(`/`)?.[1];

  console.log(location, `location`)

  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [myCarsOrOtherCars, setMyCarsOrOtherCars] = React.useState(defaultValue);

  const [logPageVisitApiHandler, logPageVisitApiData] = useLogPageVisitMutation();

  console.log(selectedCar, myCarsOrOtherCars, `selectedCar`);

  React.useEffect(() => {
    if (myCarsOrOtherCars === null) {
      if (subRoute === routes?.upcomingCarsBuyNow?.split?.('/')?.[1]) {
        navigate(`${routes.dashboardNavigation}${routes.upcomingCarsBuyNow}`);
      } else {
        navigate(`${routes.dashboardNavigation}${routes.upcomingCars}`);
      }
    }
  }, [myCarsOrOtherCars]);

  React.useEffect(() => {
    (async () => {
      await logPageVisitApiHandler({
        payload: {
          page_id: 3
        }
      });
    })();
  }, []);

  if (Vehicle_Id && myCarsOrOtherCars !== null) {
    if (myCarsOrOtherCars === 0) {
      return <UpcomingCarsDetailReadOnly />
    } else {
      return (
        <UpcomingCarsDetail setDetailView={setDetailView} selectedCar={selectedCar} />
      );        
    }

  }
  return (
    <UpcomingCarsList setDetailView={setDetailView} 
      setMyCarsOrOtherCars={setMyCarsOrOtherCars}
      onCarClick={(car, pageTab) => {
        console.log(car, `onCarClick`)
        setSelectedCar(car);
        setDetailView(true);
        navigate(`${routes.dashboardNavigation}${routes.upcomingCars}${pageTab === auctionTypes.liveAuction ? routes.liveAuction : routes.buyNow}/${car?.Vehicle_Id}`);
      }}
    />
  );
};

export default UpcomingCars;
